export default {
  "90s": [
    8963,
    8964,
    8965,
    8966,
    8967,
    8968,
    8972,
    8973,
    8974,
    8975,
    8976,
    951,
  ],
  "congrat": [
    9116,
    9117,
    9118,
  ],
  "patrik": [
    9128,
    9129,
  ],
  "birth_day": [
    9121,
    9122,
    9123,
    9124,
  ],
  "love": [
    9125,
    9126,
    9127,
  ],
  "wedding": [
    9131,
    9132,
    9133,
  ],
  "easter": [
    9119,
    9120,
  ],
  "graduate": [
    9130
  ],
  "winner": [
    9145,
    9146
  ],
  "friends": [
    9143,
    9144
  ],
  "black_and_white": [
    9307
  ]
};
